import { useRef, useCallback } from 'react'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type CallbackFunction = (...args: any[]) => void

/**
 * Hook to prevent a function from being called multiple times within a given time frame.
 *
 * @param callback The function to be called on click.
 * @param delay The debounce time in milliseconds (default: 500ms).
 */
const usePreventDoubleClick = <T extends CallbackFunction>(
  callback: T,
  delay: number = 500
): T => {
  const clickedRef = useRef(false)

  return useCallback(
    (...args: Parameters<T>) => {
      if (clickedRef.current) return

      clickedRef.current = true
      callback(...args)

      // Reset after a short delay to allow future clicks
      setTimeout(() => {
        clickedRef.current = false
      }, delay)
    },
    [callback, delay]
  ) as T
}

export { usePreventDoubleClick }
